// extracted by mini-css-extract-plugin
export default {"infinite":"index_infinite__sY+ZK","loading":"index_loading__nZcMp","spin":"index_spin__4qK6R","loadingMore":"index_loadingMore__v-MXq"};